export default __webpack_public_path__ + "static/media/ministre.c73df555.JPG";